import { useMemo } from "react";
import { useResearch } from "@/store/researchStore";

export function useAuditTrail(limit = 80) {
  const audit = useResearch((s) => s.audit);
  return useMemo(() => audit.slice(-limit).reverse(), [audit, limit]);
}
